import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import withAuthorization from '../higherOrder/withAuthorization'
import { QuestionWrapper, QuestionText, QuestionTextSpan, OptionsWrapper } from '../StyledComponents/IntroQuestions/Question'
import Option from '../IntroQuestions/Option'
import { SETTINGS } from '../../constants/routes'
import { convertIntroQuestionsToSettings } from '../../actions'

class IntroQuestionsSuccessPage extends Component {
    constructor(props) {
        super(props)

        this.onViewSettingsClicked = this.onViewSettingsClicked.bind(this)
    }

    componentDidMount() {
        this.props.convertIntroQuestionsToSettings(this.props.questions)
    }

    onViewSettingsClicked() {
        this.props.history.push(SETTINGS)
    }

    render() {
        const text = 'Thanks! Based on your answers, we created some default settings for you'
        const option = {
            label: 'View Settings',
        }

        return (
            <QuestionWrapper>
                <QuestionText>
                    <QuestionTextSpan>{text}</QuestionTextSpan>
                </QuestionText>
                <OptionsWrapper>
                    <Option
                        data={option}
                        fullWidth
                        onOptionClicked={this.onViewSettingsClicked}
                    />
                </OptionsWrapper>
            </QuestionWrapper>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    questions: state.introQuestions.questions,
})

export default compose(
    withAuthorization(authCondition),
    withRouter,
    connect(mapStateToProps, { convertIntroQuestionsToSettings })
)(IntroQuestionsSuccessPage)



// WEBPACK FOOTER //
// ./src/components/pages/IntroQuestionsSuccess.js